import { useStore } from "vuex";
 

import { createRouter, createMemoryHistory, createWebHistory } from "vue-router";
 

const routes = [
        {
    path: "/",
    name: "super admin",
    component: () => import("../SuperAdmin/SuperAdmin.vue"),
  },
         {
    path: "/dashboard",
    name: "super_admin_dashboard",
    component: () => import("../dashbord/view/MainLayout.vue"),
    children :[
       {
    path: "",
    name: "Company_super_admin_dashboard",
    component: () => import("../dashbord/dashboard.vue"),
  },
  {
    path: "/company_admin_creation",
    name: "Company_admin_creation",
    component: () => import("../dashbord/CompanyDeatails.vue"),
  },
   {
    path: "/director_details",
    name: "Company_director_creation",
    component: () => import("../dashbord/DirectorsDetails.vue"),
  },
    {
    path: "/company_creation_by_superAdmin",
    name: "company_creation_by_superAdmin",
    component: () => import("../dashbord/Company/company_creation.vue"),
  },

    {
    path: "/company_employee_creation_by_superAdmin",
    name: "company_director_creation_by_superAdmin",
    component: () => import("../dashbord/CompanyAdmin/company_admin_creation.vue"),
  },
      {
    path: "/my_company_employee_details",
    name: "company_admins_details",
    component: () => import("../dashbord/CompanyAdmin/MyAdminDetalis.vue"),
  },

        {
    path: "/my_employee_details_tree_details",
    name: "my_employee_details_tree_details",
    component: () => import("../dashbord/CompanyAdmin/EmployeeTree.vue"),
  },
    ]
  },
   
   
]; 

const router = createRouter({
  
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  }
});
//  

 

export default router;